import React, { useContext, useEffect, useState } from "react";
import styles from "./PosterResultsPopup.module.css";
import closeIcon from "../../assests/posterCreation/closeWhiteRounded.svg";
import { PopupWrapper } from "../../UI/PopupWrapper";
import nextIcon from "../../assests/posterCreation/nextIcon.svg";
import previousIcon from "../../assests/posterCreation/previousIcon.svg";
import { useNavigate } from "react-router";
import axios from "axios";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
import Lottie from "react-lottie-player";
import loadingAnimation from "../../assests/loading.json";
import MultipleEntryPopup from "../MultipleEntryPopup/MultipleEntryPopup";
import backIcon from "../../assests/posterCreation/backIcon.svg";

function PosterResultsPopup({
  visible,
  close,
  popupImageIndex,
  resultData,
  occasion,
}) {
  const {
    ocassionDataofEvent,
    preview,
    userIdToken,
    setPinData,
    setValidationComplete,
    setGeneratedPosterUrl,
    loadHomePageDetails,
    setResultUrls,
  } = useContext(Context);
  const { currentUser, searchParams, setPreviousLocation } = useUserAuth();
  const [popupImage, setPopImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(popupImageIndex);
  const navigate = useNavigate();
  const [participateLoading, setParticipateLoading] = useState(false);
  const [multipleEntryPopup, setMultipleEntryPopup] = useState(false);
  const [showVoucher, setshowVoucher] = useState(false);
  const [participate, setParticipate] = useState(false);
  const token = userIdToken || currentUser?.accessToken;
  const mode = window.location.pathname.split("/")[1]?.replace(/\.html$/, "");
  let orgDomain = ocassionDataofEvent?.orgDomain;
  let campaignUniqueText = ocassionDataofEvent?.campaignUniqueText;
  let contestUniqueText = ocassionDataofEvent?.contestUniqueText;

  useEffect(() => {
    setPopImage(resultData[currentIndex]?.result);
  }, [currentIndex]);

  const nextItem = () => {
    setCurrentIndex((prev) => (prev === resultData?.length - 1 ? 0 : prev + 1));
  };

  const prevItem = () => {
    setCurrentIndex((prev) => (prev === 0 ? resultData?.length - 1 : prev - 1));
  };

  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled = currentIndex === resultData?.length - 1;

  let value = popupImage;
  let resultValue = value?.split("/");
  let urlImageName =
    resultValue && resultValue[5]?.substring(0, resultValue[5]?.indexOf("."));

  let generatedPosterUrl = "";
  if (mode == "faceswap") {
    generatedPosterUrl = popupImage;
  } else {
    generatedPosterUrl = `https://storage.googleapis.com/goviral_posters/${occasion}/${urlImageName}.jpg`;
  }
  setGeneratedPosterUrl(generatedPosterUrl);

  const handleClick = async () => {
    if (ocassionDataofEvent?.participateWithoutShare) {
      handleParticipate();
    } else {
      navigate(`/poster/${occasion}/${urlImageName}`);
      close(false);
    }
  };

  const handleParticipate = async () => {
    try {
      setParticipateLoading(true);
      await loadHomePageDetails(orgDomain, campaignUniqueText);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_VALIDATE_UPLOAD}/${ocassionDataofEvent?.orgId}/${ocassionDataofEvent?.campaignId}/${ocassionDataofEvent?.contestId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);

      if (response.data.data.multipleEntriesFound) {
        setParticipateLoading(false);
        setMultipleEntryPopup(true);
        setshowVoucher(false);
        setParticipate(false);
      } else if (response.data.data.validationCompleted) {
        setValidationComplete(true);
        setParticipateLoading(false);

        navigate({
          pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else {
        if (response.data.data.isVoucherValid && response.status === 201) {
          setPinData(response);
          setParticipateLoading(false);

          navigate({
            pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        } else if (!response.data.data.isVoucherValid) {
          setParticipateLoading(false);

          navigate({
            pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate/error`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        }
      }
    } catch (error) {
      setParticipateLoading(false);
      navigate({
        pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate/error`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };

  return (
    <PopupWrapper visible={visible} close={close}>
      {multipleEntryPopup && (
        <MultipleEntryPopup
          buttonColor={ocassionDataofEvent?.buttonColor}
          setMultipleEntryPopup={setMultipleEntryPopup}
        />
      )}
      <div className={styles.posterResultContainer}>
        {mode == "faceswap" ? (
          <div className="w-full px-[20px]">
            <a href={`/faceswap/${occasion}`}>
              <img
                className="cursor-pointer bg-white rounded-full"
                src={backIcon}
                alt=""
                onClick={() => {
                  setResultUrls([]);
                }}
              />
            </a>
          </div>
        ) : (
          <div className="flex w-full justify-end px-[20px]">
            <img
              onClick={() => close(false)}
              src={closeIcon}
              alt=""
              className="w-[40px] h-[40px]"
            />
          </div>
        )}
        <p className="mt-[-30px] mb-[126px]"></p>
        <div className="flex justify-center items-center  relative w-full max-w-[425px] overflow-hidden">
          {/* <img className={styles.previousImage} src={previousImage} alt="" /> */}
          {popupImage ? (
            <img className={styles.currentImage} src={popupImage} alt="" />
          ) : (
            <div className="w-full h-[200px] text-center mx-auto w-[70%] flex items-center justify-center text-small-bold">
              We're unable to load this image at the moment. Please try a
              different one.
            </div>
          )}
          {/* <img className={styles.upcomingImage} src={upcomingImage} alt="" /> */}
          {!isPrevDisabled ? (
            <img
              className={styles.next}
              onClick={prevItem}
              src={previousIcon}
              alt=""
            />
          ) : (
            <img
              className={styles.nextDisabled}
              // onClick={prevItem}
              src={previousIcon}
              alt=""
            />
          )}
          {!isNextDisabled ? (
            <img
              className={styles.previous}
              onClick={nextItem}
              src={nextIcon}
              alt=""
            />
          ) : (
            <img
              className={styles.previousDisabled}
              // onClick={nextItem}
              src={nextIcon}
              alt=""
            />
          )}
        </div>
        {popupImage && (
          <div className="py-[32px]">
            <button
              onClick={() => {
                // setSelectedBackground(ocassionData?.backgrounds[currentIndex])
                // setPreviousLocation(window.location.pathname)
                handleClick();
              }}
              disabled={participateLoading}
              className="  rounded-[74px] bg-white px-[56px] py-[15px] text-black text-[16px] font-medium leading-[21px] "
            >
              {ocassionDataofEvent?.participateWithoutShare
                ? `${
                    participateLoading
                      ? "Loading"
                      : mode == "faceswap"
                      ? "Select this Photo"
                      : "Select this Poster"
                  }`
                : "Next"}
            </button>
          </div>
        )}
        {participateLoading && (
          <div className="w-[100vw] max-w-[425px] flex align-center justify-center">
            <Lottie
              loop
              animationData={loadingAnimation}
              play
              style={{ width: 100, height: 100 }}
            />
          </div>
        )}
      </div>
    </PopupWrapper>
  );
}

export default PosterResultsPopup;
